import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ProposalDetail from './ProposalDetail';
export default function ProposalShow({ proposalId }) {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(ProposalDetail, { proposalId: proposalId })));
}
